import DetailPlaceholder from './DetailPlaceholder'

export default DetailPlaceholder
// eslint-disable-next-line import/export
export * from './DetailPlaceholder'
